module.exports = __webpack_public_path__ + "img/icon-responses.8dd9f74f.svg";